import clsx from 'clsx';
import { applyMask } from '../../utils/masks';

const inputModes = {
  cep: 'numeric',
  cpf: 'numeric',
  cnpj: 'numeric',
  cpfCnpj: 'numeric',
  integer: 'numeric',
  money: 'decimal',
  phone: 'tel',
  internationalPhone: 'tel',
  plate: 'text',
  postalCode: 'text',
  registration: 'text',
};

const maxLengths = {
  cep: 9,
  cpf: 14,
  cnpj: 18,
  cpfCnpj: 18,
  phone: 15,
  internationalPhone: 25,
  plate: 7,
  postalCode: 16,
  registration: 30,
};

export default function Input({ className, mask, onChange, inputMode, maxLength, ...props }) {
  const handleChange = (event) => {
    if (mask) {
      event.target.value = applyMask(mask, event.target.value);
    }
    onChange?.(event);
  };

  return (
    <input
      className={clsx('input-base', className)}
      inputMode={inputMode || inputModes[mask]}
      maxLength={maxLength || maxLengths[mask]}
      onChange={handleChange}
      {...props}
    />
  );
}

